export default "__VITE_ASSET__pllmDzlT__"